import { doMutation } from "../../core-module/util/graphqlHelper";

export const updatePassword = passwordUpdateInput => {
  const mutation = require("../api/mutation/updatePassword.gql");
  const variables = { input: passwordUpdateInput };

  return doMutation({ mutation, variables }).then(({ data, error }) => {
    if (data) return { data: data.updatePassword };
    else if (error) return { error: JSON.stringify(error) };
  });
};
